import {JsonObject, JsonProperty} from "json2typescript";

import {Dayjs} from "../../utils/dayjs";
import {DateTimeConverter, JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentPreviewUpdateInput")
export class DocumentPreviewUpdateInput {
    @JsonProperty("expiredAt", DateTimeConverter)
    public expiredAt: Dayjs = JsonPropertyEmpty;

    public constructor(args?: Partial<DocumentPreviewUpdateInput>) {
        Object.assign(this, args);
    }
}
